// Ακυρωτικό 11.4 / πιστωτικό 5.1: τυπώνεται ΠΑΝΤΑ (απόφαση χρήστη 29/10/2026). Όταν ο server δεν το έστειλε στον
// εκτυπωτή, η οθόνη το λέει — αλλιώς ο ταμίας νομίζει ότι βγήκε χαρτί. Ο server απαντά (printCancellationDocument):
//   printed: false          → καμία εργασία εκτύπωσης (χωρίς ενεργό εκτυπωτή αποδείξεων ή σφάλμα)·
//   print_status: 'pending' → αποθηκεύτηκε, ο agent δεν είναι συνδεδεμένος (στέλνεται όταν συνδεθεί).
// Απάντηση χωρίς τα πεδία (παλιός server) → καμία προειδοποίηση.
export interface CancellationPrintResult {
  printed?: boolean;
  print_status?: string | null;
}

export function cancellationPrintWarning(
  result: CancellationPrintResult | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!result) return null;
  if (result.printed === false) return t('orders:fiscalViewer.cancelNotPrinted');
  if (result.print_status === 'pending') return t('orders:fiscalViewer.cancelPrintPending');
  return null;
}
